export default __webpack_public_path__ + "static/technical-2042780bc093bdacae1d571945f6a827.svg";